import React, { useState, useEffect } from "react"

import "../../css/typography.css"

import { LayoutMain } from "./LayoutElements"
import Navbar from "./Navbar"
import { MobileMenu, MobileMenuButton } from "./MobileMenu"
import Footer from "./Footer"
import GlobalStyle from "../../../globalStyles"

const Layout = ({ children, setTransparent }) => {
  const [open, setOpen] = useState(false)

  const toggle = () => {
    setOpen(!open)
  }

  const toggleOff = () => {
    setOpen(false)
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1)
  }, [])

  return (
    <div>
      <GlobalStyle />
      <Navbar open={open} toggle={toggleOff} setTransparent={setTransparent} />
      <MobileMenu open={open} toggle={toggle} />
      <MobileMenuButton open={open} toggle={toggle} />
      <LayoutMain>{children}</LayoutMain>
      <Footer />
    </div>
  )
}

export default Layout
